import { UserService } from '@app/core/user/services/user.service';

export const SERVICES = [
  UserService
];
